import { gatedUrlDocs } from "version"
import PostmanDocsViewer from "views/components/PostmanViewer/PostmanDocsViewer"

export function ApiDocumentation () {
  return (
    <>
      <div className="page-heading">
        <h3>Dokumentasi API</h3>
      </div>

      <div className="page-content">
        <div className="card">
          <div className="card-header">
            <PostmanDocsViewer/>
          </div>
          <div className="card-body">
             <p>
              Download Dokumentasi API{' '}
              <a target="_blank" rel="noreferrer" href={gatedUrlDocs}>
                POSTMAN
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default ApiDocumentation
